import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input } from "antd";
import PropTypes from "prop-types";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import InputCurrency from "components/InputCurrency";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = ({ data = {}, onUpdate }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting, visible } = state;
	const { id, title } = data;
	const [form] = Form.useForm();
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				const action =
					hash === `#${Modals.CREATE}`
						? API.subscription.create(values)
						: API.subscription.update(id, values);

				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				action
					.then(() => {
						onUpdate(null, true);
						navigate(-1);
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({ ...prevState, visible: true }));

					form.setFieldsValue(data);
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={
				<>
					<Button type="primary" onClick={handleSubmit} loading={submitting}>
						{Resources.confirm}
					</Button>
					<Button onClick={() => navigate(-1)} loading={submitting}>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={
				hash === `#${Modals.CREATE}`
					? `${Resources.add} ${Resources.subscription}`
					: `${Resources.edit} ${Resources.subscription} "${title}"`
			}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form layout="vertical" form={form}>
				<Form.Item name="title" label={Resources.title} rules={Rules.required}>
					<Input />
				</Form.Item>
				<Form.Item name="price" label={Resources.price} rules={Rules.required}>
					<InputCurrency />
				</Form.Item>
				<Form.Item
					name="duration"
					label={Resources.duration}
					rules={Rules.required}
				>
					<Input suffix={Resources.day} />
				</Form.Item>
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
};

export default Component;
